<template>
    <div>
        <div class="actions">
            <h3 style="font-size:28px;line-height:45px">Help</h3>
        </div>
        <p>Here. you will find articles and useful materials to help answer some of your questions about our services at Cowtribe.</p>
        <div>
            <a-collapse :bordered="false">
                <a-collapse-panel style="color:#434343;" key="1" header="Do you ship your products to EU?">
                    <p>No, currently we do not support EU shipping.</p>
                </a-collapse-panel>
                <a-collapse-panel style="color:#434343;" key="2" header="What are the shipping options?" :disabled="false">
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                    </p>
                </a-collapse-panel>
                <a-collapse-panel key="3" style="color:#434343;" header="What are the international taxes, duties, etc. that I have to pay?">
                    <p>
                        Facilisis leo vel fringilla est ullamcorper. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus. Nulla at volutpat diam ut venenatis tellus in metus vulputate. Faucibus pulvinar elementum integer enim neque volutpat ac. Consequat interdum
                    </p>
                </a-collapse-panel>
                <a-collapse-panel key="4"  style="color:#434343;" header="When will I receive my order?">
                    <p>
                        Odio tempor orci dapibus ultrices in iaculis nunc sed augue, that you can read here.
                    </p>
                </a-collapse-panel>
            </a-collapse>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Help'
    }
</script>

<style scoped>

</style>